import { FILTER_OPTIONS } from "../functions";
import DropdownFilter from "../../simulatorLineup/dropdownFilter/dropdownFilter";
import { useRef, forwardRef, useState, useEffect } from "react";
import "./positionFilter.sass";

/**
 * Filtro de posición con dropdown personalizado
 * 
 * Componente que reemplaza el select nativo con un dropdown
 * personalizado. Permite filtrar jugadores por posición con una
 * interfaz mejorada.
 * 
 * @component
 * @param {string} value - Valor actual del filtro ("all" o posición específica)
 * @param {Function} onChange - Callback al cambiar el filtro (recibe nuevo valor)
 * @param {string} [accentColor] - Color de acento para estilos (hex o CSS var)
 * 
 * @returns {JSX.Element} Dropdown con opciones de filtro
 */
const PositionFilter = forwardRef(({ value, onChange, accentColor }, ref) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 780);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 780);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // En mobile, renderizar botones en lugar de dropdown
  if (isMobile) {
    return (
      <div className="position-filter-buttons">
        {FILTER_OPTIONS.map((option) => (
          <button
            key={option.value}
            className={`position-filter-buttons__btn ${value === option.value ? "active" : ""}`}
            onClick={() => onChange(option.value)}
            style={value === option.value && accentColor ? { background: accentColor } : undefined}
          >
            {option.label.toUpperCase()}
          </button>
        ))}
      </div>
    );
  }

  // En desktop, renderizar dropdown
  return (
    <DropdownFilter
      ref={ref}
      options={FILTER_OPTIONS}
      value={value}
      onChange={onChange}
      ariaLabel="Filtrar por posición"
      accentColor={accentColor}
      containerClass="position-filter-container"
      buttonClass="position-filter-button"
      dropdownClass="position-filter-dropdown"
      optionClass="position-filter-option"
    />
  );
});

PositionFilter.displayName = "PositionFilter";

export default PositionFilter;